import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const TriangleExclamationFillIcon = ({
  color = 'black',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
  title = 'Error',
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginLeft={marginLeft}
    marginRight={marginRight}
    containerSize={containerSize}
    width={width}
    title={title}
  >
    <svg
      width={Number(width)}
      height={Number(width)}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8963 2.52941C11.498 1.82353 10.502 1.82353 10.1037 2.52941L1.14021 18.4118C0.741834 19.1176 1.2398 20 2.03655 20H19.9634C20.7602 20 21.2582 19.1176 20.8598 18.4118L11.8963 2.52941ZM11 13C11.4038 13 11.7362 12.6826 11.755 12.2793L11.9536 7.99893C11.9789 7.45489 11.5446 7 11 7C10.4554 7 10.0211 7.45489 10.0464 7.99892L10.245 12.2793C10.2638 12.6826 10.5962 13 11 13ZM11.0056 17C11.6089 17 12 16.5714 12 16C11.9888 15.4066 11.5978 15 11.0056 15C10.4134 15 10 15.4066 10 16C10 16.5714 10.4022 17 10.9944 17H11.0056Z"
        fill={getSemanticTextColor(color)}
      />
    </svg>
  </DefaultIconWrapper>
);
